import { getHttpClient } from "@/core/api";

export async function getFeatures() {
  const response = await getHttpClient().get(`/v2/features`);
  return response.data;
}
